<td-layout-nav>
  <mat-sidenav-container class="td-layout-nav-list">
<!--    <mat-sidenav #sidenav mode="side">-->
<!--      <mat-nav-list td-sidenav-content>-->
<!--      </mat-nav-list>-->
<!--    </mat-sidenav>-->
    <mat-card id="main">
      <kraft-header-template [labelText]="headerDescName" [templateText]="'Herzlich Willkommen beim MBP-Tool!'">
        Header-Template
      </kraft-header-template>
      <router-outlet></router-outlet>
    </mat-card>
  </mat-sidenav-container>
  <td-layout-footer>
    <div layout="row" layout-align="start center">
      <span class="mat-caption">Allianz &copy; 2018 MBP-Tool. Version {{version}}</span>
    </div>
  </td-layout-footer>
</td-layout-nav>
